export const TO_CONFIRM = "TO_CONFIRM";
export const CONFIRMED = "CONFIRMED";
export const SHOW = "SHOW";
export const NO_SHOW = "NO_SHOW";
export const CANCELLED = "CANCELLED";
export const NEED_TABLE = "NEED_TABLE";
export const DONE = "DONE";
